module.exports = __webpack_public_path__ + "img/subcategories_less_radius.65d9b7c9.svg";